import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface TitleContextType {
    title: string;
    setTitle: (title: string) => void;
}

const TitleContext = createContext<TitleContextType>({ title: "", setTitle: (title: string) => {} });

export const TitleProvider = ({ children }: { children: ReactNode }) => {
    const [title, setTitle] = useState("");

    useEffect(() => {
        if(!title){
            document.title = "Foundations - "
        }
        else{
            document.title = "Foundations - " + title;
        }
    }, [title]);

    return (
        <TitleContext.Provider value={{ title, setTitle }}>
            {children}
        </TitleContext.Provider>
    );
};

export const useTitleContext = () => {
    const context = useContext(TitleContext);
    return context;
};